if (!customElements.get('purchase-options')) {
  customElements.define(
    'purchase-options',
    class PurchaseOptions extends HTMLElement {
      connectedCallback() {
        this.sellingPlanInput = this.querySelector('[data-role="selling-plan-input"]');
        this.frequencySelect = this.querySelector('[data-role="frequency"]');
        this.cards = Array.from(this.querySelectorAll('.purchase-options__card'));

        this.addEventListener('change', this.handleChange.bind(this));
        this.updateSellingPlanValue();
      }

      handleChange(event) {
        if (event.target.type === 'radio' || event.target.dataset.role === 'frequency') {
          this.updateSelectedCard();
          this.updateSellingPlanValue();
        }
      }

      updateSelectedCard() {
        const selectedOption = this.querySelector('input[type="radio"]:checked')?.value;
        this.cards.forEach((card) => {
          card.classList.toggle('is-selected', card.dataset.option === selectedOption);
        });
      }

      updateSellingPlanValue() {
        if (!this.sellingPlanInput) return;

        const selectedOption = this.querySelector('input[type="radio"]:checked')?.value;

        if (selectedOption !== 'subscription') {
          this.sellingPlanInput.value = '';
          return;
        }

        if (this.frequencySelect) {
          this.sellingPlanInput.value = this.frequencySelect.value;
        } else {
          const subscriptionCard = this.querySelector('[data-option="subscription"]');
          this.sellingPlanInput.value = subscriptionCard?.dataset.planId || '';
        }
      }
    }
  );
}
